import { RaceCardSchema } from './RaceCards.styles';

export const raceCardStyles: RaceCardSchema = {
  buttonRaceCardOddsProps: {
    variant: 'odds',
    h: '36px',
    w: '42px',
  },
};
